import React from "react";

import { Box, CompassColor, Icon, useMediaQuery } from "@noom/wax-component-library";

import { NoomHeader } from "@/components/noom-branding";
import { useHeaderContext } from "@/contexts";

type BaseOutlineProps = {
  backgroundColor?: CompassColor | string;
  children?: React.ReactNode;
  hideHeader?: boolean;
};

export const BaseOutline: React.FC<BaseOutlineProps> = ({
  backgroundColor = CompassColor.white,
  children,
  hideHeader = false,
}) => {
  const [isBrowser] = useMediaQuery("(min-width: 1160px)", { ssr: false });
  const { onClose } = useHeaderContext();

  if (!isBrowser) {
    return (
      <Box position={onClose ? "relative" : undefined}>
        {!hideHeader && <NoomHeader />}
        <Box
          backgroundColor={backgroundColor}
          display="flex"
          flexDirection="column"
          minHeight="calc(100vh - 64px)"
        >
          {children}
        </Box>
        {onClose && (
          <Box position="absolute" top="var(--spacing-l)" right="var(--spacing-m)">
            <button type="button" onClick={onClose} aria-label="Close">
              <Icon icon="close" />
            </button>
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Box height="100vh">
      <NoomHeader />
      <Box
        backgroundColor="#F4F4F4"
        height="calc(100vh - 64px)"
        padding="var(--spacing-l) 314px"
      >
        {/*
          The question height is the content height (100vh - 64px) minus the
          padding on each side: var(--spacing-l) (24px)

          100vh - 64px - 24px - 24px = 100vh - 112px
        */}
        <Box
          backgroundColor={backgroundColor}
          display="flex"
          flexDirection="column"
          height="calc(100vh - 112px)"
          overflowY="auto"
          position="relative"
        >
          {children}
          {onClose && (
            <Box position="absolute" top="var(--spacing-l)" right="var(--spacing-m)">
              <button type="button" onClick={onClose} aria-label="Close">
                <Icon icon="close" />
              </button>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
